import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { PreCompanyRepository } from "../domain/PreCompanyRepository";
import { PreCompanyValidate } from "../domain/PreCompanyValidate";
import { PreCompany } from "../domain/PreCompany";
import { VectiResult } from "~/context/Shared/domain/VectiResult";

export function createApiPreCompanyRepository(): PreCompanyRepository {
  return new ApiPreCompanyRepository();
}

export class ApiPreCompanyRepository
  extends APIRepository
  implements PreCompanyRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  async validateCompany(preCompanyValidate: PreCompanyValidate): Promise<void> {
    console.log("(ApiPreCompanyRepository) call validateCompany", JSON.stringify(preCompanyValidate));
    try {
      const ret = await this.doPostNew("/api/welcome/validateCompany", null, {
        ...preCompanyValidate,
        legalId: preCompanyValidate.legalId,
        companyName: preCompanyValidate.companyName,
      });
    console.log("(ApiPreCompanyRepository) return:" + JSON.stringify(ret));
return ret;
    } catch (error: any) {
      console.log("(ApiPreCompanyRepository) error: " + JSON.stringify(error));
      const errorData = JSON.parse(JSON.stringify(error));
      if (error?.type === "PreCompanyExistsAsCompanyOnVectiError") {
        console.log("PreCompanyExistsAsCompanyOnVectiError");
        return Promise.reject();
      }
      console.log("(ApiPreCompanyRepository) error validateCompany:" + errorData?.body?.message);
      return Promise.reject(errorData?.body?.message);
    }
  }

  saveCompany(preCompanyValidate: PreCompanyValidate): Promise<void> {
    console.log("(ApiPreCompanyRepository) call saveCompany", JSON.stringify(preCompanyValidate));
    try {
      return this.doPostNew("/api/welcome/saveCompany", null, {
        ...preCompanyValidate,
        legalId: preCompanyValidate.legalId,
        companyName: preCompanyValidate.companyName,
        companyAddress: preCompanyValidate.companyAddress,
        companyCity: preCompanyValidate.companyCity,
        companyState: preCompanyValidate.companyState,
        companyZip: preCompanyValidate.companyZip,
        companyCountry: preCompanyValidate.companyCountry,
        companyEmail: preCompanyValidate.companyEmail,
        companyPhone: preCompanyValidate.companyPhone,
        companyWebsite: preCompanyValidate.companyWebsite,
      });
    } catch (error: any) {
      console.log("error saveCompany:" + error);
      return Promise.reject();
    }
  }

  validateCompanyGetCompany(preCompanyValidate: PreCompanyValidate): Promise<PreCompanyValidate> {
    console.log("(ApiPreCompanyRepository) call validateCompanyGetCompany", JSON.stringify(preCompanyValidate));

    try {

      return this.doGet<PreCompanyValidate>("/api/welcome/validateCompanyGetCompany/legalId/" + preCompanyValidate.legalId + "/companyName/" + preCompanyValidate.companyName);

    } catch (error) {
      console.log("error validateCompany:" + error);
      return Promise.reject();
    }
  }

  getByLegalId(legalId: string): Promise<PreCompany> {
    //console.log("call getByLegalId", JSON.stringify(legalId));

    try {

      return this.doGet<PreCompany>("/api/precompanies/legalId/" + legalId);

    } catch (error) {
      console.log("error getByLegalId:" + error);
      return Promise.reject();
    }
  }

  async getByUser(userId: string): Promise<PreCompany> {
    try {
      const myPreCompanies = await this.listByUser(userId);
      return myPreCompanies[0];
    } catch (error) {
      console.log("error getByUser:" + error);
      return Promise.reject();
    }
  }

  async getByPreUser(): Promise<VectiResult> {
    try {
      const preCompany = await this.getByPreUserIncomplete();
      console.log("getByPreUser:" + JSON.stringify(preCompany ) );
      return preCompany;

    } catch (error) {
      console.log("error getByUser:" + error);
      return Promise.reject();
    }
  }

  getByPreUserIncomplete(): Promise<VectiResult> {
    return new Promise(async (resolve) => {
	      const resp = await this.doGet("/api/precompanies/incomplete");

      console.log("ret resp:" + JSON.stringify(resp));
      console.log("Array.isArray(resp):" + Array.isArray(resp));
    console.log("Array.isArray(resp):" + (Array.isArray(resp) && resp.length) );
      if (Array.isArray(resp) && resp.length === 0) {
        resolve(new VectiResult(false, resp));
        return;
      }else{
        resolve(new VectiResult(true, resp));
      }
      
      
    }).then((response: any) => {
      console.log("response:" + JSON.stringify(response));
      if (response?.type?.code === 5004) {
        throw new Error(response.message);
      } else {
        //console.log("otro mensaje");
      }
      return response;

    }).catch((error: any) => {
      console.log("error Api Respository: " + error);

      throw error;
    });

/*
    try {
      const resp = this.doGet("/api/precompanies/incomplete");
      resp.then()
      if(ret.) 
      return this.doGet<PreCompany>("/api/precompanies/incomplete");
    } catch (error) {
      console.log("error getByPreUserIncomplete:" + error);
      return Promise.reject();
    }
   */
  }

  listByUser(userId: string): Promise<PreCompany[]> {
    try {
      return this.doGet<PreCompany[]>("/api/precompanies/" + userId);
    } catch (error) {
      console.log("error listByUser:" + error);
      return Promise.reject();
    }
  }



}
